.alert-create-form .ant-form-item {
    margin-bottom: 0.5rem;
}

.alert-create-segmented .ant-segmented-group {
    align-items: stretch;
}

.alert-create-segmented .ant-segmented-item {
    display: flex;
    align-items: stretch;
}

.alert-create-segmented .ant-segmented-item-label {
    display: flex;
    align-items: center;
    justify-content: center;
}
